import { Slices } from "interface/sharedJsInterface";

export const {
  accreditors,
  boardExamDates,
  cmeActivities,
  cmeActivityTrackers,
  cmeCertificates,
  cmeCoach,
  cmeCreditTrackers,
  cmeQuestionBanks,
  creditCards,
  notifications,
  organizationalSubscriptions,
  riskAssessment,
  staticData,
  assignments,
  organizations,
  organizationalMemberships,
  memberGroups,
  modal,
  questionBanks,
  subjects,
  categories,
  clinicalPearls,
  performanceAllStudents,
  performanceOrgPeers,
  performancePeers,
  performanceQuestions,
  performanceResponses,
  performanceQuizzes,
  responses,
  quizzes,
  questions,
  productPages,
  reports,
  sessions,
  classReports,
  products,
  practiceExamTemplates,
  deviceRegistrations,
  memberGroupMembers,
  staffOrganizations,
  addonAccessTrackers,
  notes,
  highlights,
  strikeThroughs,
  quizBlocks,
  subscriptions,
  examTemplates,
  users
} = Slices;
